function hashUrl(value: string): string {
    let hash = 2166136261
    for (let index = 0; index < value.length; index++) {
        hash = Math.imul(hash ^ value.charCodeAt(index), 16777619)
    }
    return (hash >>> 0).toString(36)
}

export function collectionIdFromUrl(rawUrl: string): string {
    const url = new URL(rawUrl)
    const host = url.hostname
        .toLowerCase()
        .replace(/^www\./u, '')
        .replace(/[^a-z0-9]+/gu, '-')
        .replace(/^-|-$/gu, '')
        .slice(0, 20) || 'source'
    return `${host}-${hashUrl(url.toString())}`.slice(0, 32)
}
